module.exports = __webpack_public_path__ + "assets/img/three.9fa25e15.png";